//
//
//
//
//
//

// 加载所需icon文件
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/icons', true, /\.svg$/)
requireAll(req)
export default {
  name: 'icon',
  props: [
    'symbol',
    'className'
  ],
  computed: {
    iconClass () {
      const {symbol, className} = this
      return className ? `Icon Icon-${symbol} ${className}` : `Icon Icon-${symbol}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/icons/index.vue